module.exports = __webpack_public_path__ + "static/media/features-bg.272e6086.png";